class Observer {
    /**
     * @return {string}
     * @private
     */
    _getId = () => Date.now() + Math.random().toString()
    /**
     * @type {{}}
     * @private
     */
    _watchers = {}

    /**
     * @param key {string}
     * @param callback {function(newValue: string)}
     * @return {function(): void}
     */
    watch(key, callback) {
        const id = this._getId()
        if (!this._watchers[key]) {
            this._watchers[key] = {}
        }
        this._watchers[key][id] = callback
        return () => {
            delete this._watchers[key][id]
        }
    }

    /**
     * @param key {string}
     * @param [data] {any}
     */
    trigger(key, data) {
        if (this._watchers[key]) {
            const callbacks = Object.values(this._watchers[key])
            callbacks.forEach((cb) => cb(data))
        }
    }
}

export const observer = new Observer()
